<p>lector-qr works!</p>
